/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobServiceAccountQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("TemplateJobServiceAccountQueryOperator");
    }

    getFixupPrototypeFunction() { return TemplateJobServiceAccountQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobServiceAccountQueryOperator>): TemplateJobServiceAccountQueryOperator {
        let obj = Object.assign(new TemplateJobServiceAccountQueryOperator(), model);
        TemplateJobServiceAccountQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobServiceAccountQueryOperator>): TemplateJobServiceAccountQueryOperator {
        if (!model) return null;
        return TemplateJobServiceAccountQueryOperator.newInstance(<TemplateJobServiceAccountQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobServiceAccountQueryOperator) {
        if (!obj) return;

        models.TemplateJobServiceAccountQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobServiceAccountQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TemplateJobServiceAccountQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service account IDs to include
     */
    service_account_ids: Array<string>;

}
